import { Fotografija } from 'kzv-icons';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';

import Button from '../buttons/Button';

interface DropzoneProps {
    accept: string | string[];
    multiple: boolean;
    maxSize?: number;
    maxFiles: number;
    onAcceptedFiles: (files: File[]) => void;
    disabled?: boolean;
}

function Dropzone({ accept, multiple, maxSize = 15, maxFiles = 15, onAcceptedFiles, disabled }: DropzoneProps) {
    const maxSizeInBytes = maxSize * 100 * 100 * 100;

    const handleDrop = (acceptedFiles, rejectedFiles) => {
        if (disabled) return;

        onAcceptedFiles(acceptedFiles.slice(0, maxFiles));

        if (acceptedFiles.length > maxFiles) {
            toast(`Nekaj datotek ni bilo naloženih. Največje število datotek: ${maxFiles}`, {
                icon: 'ℹ️'
            });
        }

        if (rejectedFiles.length) {
            rejectedFiles.map((error) => {
                const { file } = error;
                let errorMessage = '';
                if (file.size > maxSizeInBytes) {
                    errorMessage += `Datoteka ${file.name} je prevelika. Maksimalna velikost: ${maxSize} mb`;
                } else {
                    errorMessage = `Datoteka ${file.name} je bila zavrnjena.`;
                }
                toast.error(errorMessage);
            });
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop,
        accept,
        multiple,
        maxSize: maxSizeInBytes
    });

    return (
        <div className={`${disabled ? 'disabled' : ''}`}>
            <div
                className={`p-6 flex flex-col sm:flex-row outline-none gap-4 justify-center items-center border border-gray-400 border-dashed rounded-lg ${
                    isDragActive ? 'bg-brand-light opacity-70' : 'bg-white'
                }  hover:bg-gray-200 hover:cursor-pointer`}
                {...getRootProps()}
            >
                <input {...getInputProps()} />
                <div className="hidden sm:block">
                    <img
                        alt="Izberi fotografije"
                        className="h-16 sm:h-28 mr-4 object-contain"
                        src="/images/photos-illustration.svg"
                    />
                </div>
                <div className="flex-shrink">
                    <div className="mt-2 text-left">
                        <div className="sm:hidden">
                            <Button
                                variant="outlined"
                                color="secondary"
                                endIcon={<Fotografija strokeWidth={1.2} width={26} height={26} />}
                            >
                                {maxFiles > 1 ? 'Izberi fotografije' : 'Izberi fotografijo'}
                            </Button>
                        </div>
                        <div className="hidden sm:block">
                            Povleci {maxFiles > 1 ? 'fotografij' : 'fotografijo'} v to polje ali{' '}
                            <span className="text-brand font-medium underline">izberi</span> iz računalnika.
                            {maxFiles > 1 && (
                                <div className="mt-1 text-secondary text-sm italic">
                                    Največ {maxFiles} fotografij v formatu .jpg ali .png.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dropzone;
